import AutomationIcon from '@atlaskit/icon/core/automation';
import * as React from 'react';

export function SvgZapOutline() {
  return <AutomationIcon label="" testId="ads-refreshed-icon" />;
}
